<div class="card-wrapper h-full w-full flex justify-center m-0 p-0 items-center relative" #chartContainer>
  <div [id]="chartId" class="chart-container h-full w-full"></div>
</div>